import React from 'react';
import { useEffect, useState, useContext } from 'react';
import Markdown from 'markdown-to-jsx';
import { getSolutionDetails } from './helper';
import Loading from '@svb/api-loading-component/dist/components/index';
import { SVBCard, SVBContentsTable } from '@svb/svb-react-components';
import SolutionDetailsBenefits from './SolutionDetailsBenefits';
import SolutionDetailsApisInvolved from './SolutionDetailsApisInvolved';
import SolutionDetailsHowItWorks from './SolutionDetailsHowItWorks';
// import { SVBSolutionsHeader } from '@svb/portal-ui-react-components';
import SVBSolutionsHeader from './SVBSolutionsHeader';
import { SVBCTABlock } from '@svb/portal-ui-react-components';
import SolutionDetailsGettingStarted from './SolutionDetailsGettingStarted';
import SolutionDetailsTechnicalGuide from './SolutionDetailsTechnicalGuide';
import DetailsProvider, { detailsContext } from './context/DetailsProvider';
import { SVBErrorPageRenderer } from '../../helpers/utilityFunctions';
const SolutionDetailsContainer = ({ children }) => {
  return <section className='solutions_solutionDetails_main_wrapper row'>{children}</section>;
};

const SolutionDetailsApisContainer = ({ children }) => {
  return <section className='solutions_solutionDetails_main_wrapper row'>{children}</section>;
};

const SolutionDetailsHowItWorksContainer = ({ children }) => {
  return <section className='how-it-works-section-content'>{children}</section>;
};

const SolutionDetailsRightWrapper = () => {
  const { contentTitlesObject } = useContext(detailsContext);
  const newArr = contentTitlesObject.filter((value, index, self) => {
    return (
      index === self.findIndex((t) => t.displayText === value.displayText && t.id === value.id)
    );
  });
  return (
    <div className='solutions_solutionDetails_right_wrapper col-2'>
      <SVBContentsTable items={newArr} />
    </div>
  );
};

const SolutionDetailsLeftWrapper = ({ children }) => {
  return (
    <div className='solutions_solutionDetails_left_wrapper col-lg-10 col-md-12 col-sm-12'>
      {children}
    </div>
  );
};

const BenefitCard = ({ externalLink, cardContentText, cardHeaderText }) => {
  return (
    <div className='solutions_solutionDetails_benefitCard col-sm-12 col-md-6 col-lg-4'>
      <SVBCard
        cardIcon={'CheckCircle.svg'}
        link={externalLink}
        titleSeparator={true}
        title={cardHeaderText}
        description={cardContentText}
        buttonLabel=' '
        extraClasses='benefits-card p-3'
        cardOptions={{ cardClickable: false }}
        explicitImgWidth={32}
        explicitImgHeight={32}
        lazyLoading={true}
      />
    </div>
  );
};
const SolutionDetails = (props) => {
  const [loading, setloading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatusCode, setErrorStatusCode] = useState('');
  const [errorDefaultMessage, setErrorDefaultMessage] = useState(
    'It happens sometimes, you may refresh the page or go to home.',
  );
  const solDetails = getSolutionDetails(props.url, props.solType, props.details);
  //  const solDetails = Utils.getFileContent(
  //    '/solutions/solution-details/virtual-cards.md'
  //  );
  useEffect(() => {
    setIsError(false);
    if (solDetails.type === 'success') {
      setloading(false);
    }

    if (solDetails.type === 'error') {
      setIsError(true);
      setErrorStatusCode(solDetails?.errorStatusCode);
      !solDetails?.errorStatusCode && setErrorDefaultMessage(solDetails?.response);
      setloading(false);
    }
  }, [solDetails]);

  if (isError) {
    return (
      <SVBErrorPageRenderer
        errorStatusCode={errorStatusCode}
        defaultErrorMessage={errorDefaultMessage}
      />
    );
  }

  // render solution-details if present otherwise print generic message
  if (solDetails?.response && typeof solDetails?.response === 'string') {
    return loading ? (
      <Loading />
    ) : (
      <>
        {/* {solDetails === 'No Content' && (
          <div className='solutions-loading'>
            <Loading />
          </div>
        )} */}
        <Markdown
          options={{
            overrides: {
              DetailsProvider: {
                component: DetailsProvider,
              },
              Container: {
                component: SolutionDetailsContainer,
              },
              LeftWrapper: {
                component: SolutionDetailsLeftWrapper,
              },
              RightWrapper: {
                component: SolutionDetailsRightWrapper,
              },
              Hero: {
                component: SVBSolutionsHeader,
              },
              SolutionDetailsBenefits: {
                component: SolutionDetailsBenefits,
              },
              Card: {
                component: BenefitCard,
              },
              HowItWorksContainer: {
                component: SolutionDetailsApisContainer,
              },
              SolutionDetailsGettingStarted: {
                component: SolutionDetailsGettingStarted,
                props: props,
              },
              SolutionDetailsApisInvolved: {
                component: SolutionDetailsApisInvolved,
                props: props,
              },
              SolutionDetailsHowItWorksContainer: {
                component: SolutionDetailsHowItWorksContainer,
              },
              SolutionDetailsHowItWorks: {
                component: SolutionDetailsHowItWorks,
              },
              SolutionDetailsTechnicalGuide: {
                component: SolutionDetailsTechnicalGuide,
                props: props,
              },
              SVBContentsTable: {
                component: SVBContentsTable,
              },
            },
          }}
        >
          {solDetails?.response}
        </Markdown>
        <SVBCTABlock
          title='Didn’t find what you’re looking for?'
          content='Check out other use cases in the Solutions Catalog or contact us with any questions you may have.'
          primaryButton='Contact Us'
          primaryUrl='/contact'
          secondaryButton='Solutions Catalog'
          secondaryUrl='/solutions'
          extraClasses='solutions-link'
          color='none'
        />
      </>
    );
  }
};

export default SolutionDetails;
